import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputBase from '@material-ui/core/InputBase';
// import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tooltip from 'eventtia-ui-components/lib/Tooltip';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import ConfidentialityIcon from '../../assets/sidebarIcons/Confidentiality';

const StyledInputBase = withStyles((theme) => ({
  root: {
    // marginTop: theme.spacing(1.5),
  },
  input: {
    fontWeight: 400,
    color: theme.palette.darkGrey.main,
    position: 'relative',
    backgroundColor: theme.palette.lightGrey.main,
    fontSize: 16,
    width: '100%',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontFamily: 'Brilliant Cut Pro',
    padding: '8px 10px 3px',
    '&:focus': {
      borderColor: theme.palette.darkGrey.main,
    },
  },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
  label: {
    display: 'flex',
    alignItems: 'center',
  },
  labelText: {
    fontSize: 14,
    fontWeight: '400',
    color: theme.palette.darkGrey.main,
    fontFamily: 'Brilliant Cut Pro',
    marginBottom: 5,
    lineHeight: 1,
    letterSpacing: 1,
  },
  helperIcon: {
    flexShrink: 0,
    '& svg': {
      marginLeft: theme.spacing(1),
      fontSize: 18,
    },
  },
  multiline: {
    // backgroundImage: 'repeating-linear-gradient(to bottom,
    // transparent, transparent 25px, #9E9E9E 25px, #9E9E9E 26px)',
    backgroundSize: '100% 26px',
    lineHeight: '26px',
    border: 'none',
  },
}));

const StyledFormHelperText = withStyles((theme) => ({
  root: {
    margin: theme.spacing(1, 0, 0),
  },
}))(FormHelperText);

const InputBaseStyled = ({
  variant, margin, id, label, helperText, multiline, rows, rowsMax,
  handleChange, InputProps, error, ...other
}) => {
  const classes = useStyles();

  return (
    <FormControl variant={variant} fullWidth>
      <label htmlFor={id} className={clsx(classes.label, 'custom-input-label')}>
        <Tooltip title={label}>
          <div className={classes.labelText}>
            {label} {other.required && '*'}
          </div>
        </Tooltip>
        {!!helperText && (
          <Tooltip title={helperText || label}>
            <div className={classes.helperIcon}>
              <ConfidentialityIcon />
            </div>
          </Tooltip>
        )}
      </label>
      <StyledInputBase
        id={id}
        margin={margin}
        onChange={handleChange ? ((e) => handleChange(e.target.value)) : undefined}
        multiline={multiline}
        rows={multiline ? rows : undefined}
        rowsMax={multiline ? rowsMax : undefined}
        classes={{ input: multiline ? classes.multiline : undefined }}
        {...other}
      />
      {!!error && (
        <StyledFormHelperText error={!!error}>{error}</StyledFormHelperText>
      )}
    </FormControl>
  );
};

InputBaseStyled.propTypes = {
  variant: PropTypes.string,
  multiline: PropTypes.bool,
  margin: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.node,
  helperText: PropTypes.node,
  rows: PropTypes.number,
  rowsMax: PropTypes.number,
  handleChange: PropTypes.func,
  InputProps: PropTypes.shape({
    readOnly: PropTypes.bool,
  }),
  error: PropTypes.string,
};

InputBaseStyled.defaultProps = {
  handleChange: undefined,
  multiline: false,
  variant: 'outlined',
  rowsMax: 6,
  margin: 'none',
  id: undefined,
  label: undefined,
  helperText: undefined,
  rows: 3,
  InputProps: undefined,
  error: undefined,
};

export default InputBaseStyled;
